module.exports = __webpack_public_path__ + "stylesheets/spinners_c054ba0e20568d4283df5ef9c5653ec0.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/spinners.less
// module id = u8E4
// module chunks = 151